// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShareSiHaDocumentationRequestModel from '../../model/share-si-ha-documentation-request-model';
import ShareSiHaDocumentationRequestDTO from '../dto/share-si-ha-documentation-request-dto';
import dtoSchema from '../schemas/share-si-ha-documentation-request-schema';

export default abstract class ShareSiHaDocumentationRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShareSiHaDocumentationRequestDTO>) {
    super();
    if (data) {
      this.sendToEmailAddress = data.sendToEmailAddress;
      this.shareLink = data.shareLink;
      this.id = data.id;
    }
  }
  /**
  * @minimum 1
  * @type {email}
  */
  sendToEmailAddress?: string;
  /**
  * @minimum 1
  */
  shareLink?: string;
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<ShareSiHaDocumentationRequestDTO>): ShareSiHaDocumentationRequestModel;
  static toModel(dto: DeepPartial<ShareSiHaDocumentationRequestDTO> | undefined | null): ShareSiHaDocumentationRequestModel | undefined;
  static toModel(dto: DeepPartial<ShareSiHaDocumentationRequestDTO> | undefined | null): ShareSiHaDocumentationRequestModel | undefined {
    return dto ? new ShareSiHaDocumentationRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShareSiHaDocumentationRequestModel> | ShareSiHaDocumentationRequestModel): ShareSiHaDocumentationRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      sendToEmailAddress: unwrapped.sendToEmailAddress,
      shareLink: unwrapped.shareLink,
      id: unwrapped.id,
    } as ShareSiHaDocumentationRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShareSiHaDocumentationRequestModel, can not map to ShareSiHaDocumentationRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
